import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function BestTaxiServiceInMumbai() {



    const cardData = {




keyword: "Best Taxi Service in Mumbai",

headingDescription: "Shreesha Tours & Travels is proud to offer one of the best taxi services in Mumbai with safe, reliable, and affordable transportation for local travel, airport transfers, corporate travel, outstation journeys, sightseeing tours, railway station transfers, and long-distance trips across Maharashtra and India. We provide one-way cabs, round-trip taxi services, hourly rental packages, chauffeur-driven vehicles, and customized travel solutions for families, business travelers, tourists, students, and corporate clients. Our modern fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles to meet every travel requirement and budget. With doorstep pickup across Mumbai, experienced and verified drivers, transparent pricing, easy online booking, and 24/7 customer support, Shreesha Tours & Travels ensures a smooth, comfortable, and hassle-free journey. Whether you need a taxi for business meetings, airport pickup and drop, hotel transfers, destination weddings, family vacations, pilgrimage tours, or outstation travel, our professional cab service delivers punctuality, clean vehicles, and exceptional customer satisfaction on every ride.",

topPlaces: [
   {
    title: "Goa",
    description: "Goa is India's most popular beach destination, known for beautiful beaches, water sports, Portuguese churches, vibrant nightlife, forts, and seafood. It is one of the most booked outstation cab routes from Mumbai."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is renowned for the Mahalakshmi Temple, Rankala Lake, Panhala Fort, traditional cuisine, and rich Maratha heritage. It is an excellent destination for religious and historical tourism."
  },
  {
    title: "Lonavala",
    description: "Lonavala is one of the most popular hill stations near Mumbai, famous for Tiger Point, Bhushi Dam, Rajmachi Fort, lush green valleys, waterfalls, and pleasant weather. It is a preferred destination for weekend trips and family vacations."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station known for Venna Lake, Arthur's Seat, Elephant's Head Point, strawberry farms, and breathtaking viewpoints. It is ideal for couples, families, and nature lovers."
  },
  {
    title: "Panchgani",
    description: "Panchgani attracts tourists with its scenic Table Land, Sydney Point, Parsi Point, Mapro Garden, and pleasant climate. It is one of the best weekend getaway destinations from Mumbai."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, home to the sacred Shri Sai Baba Samadhi Mandir. Thousands of devotees travel from Mumbai every day for darshan and spiritual experiences."
  },
  {
    title: "Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, Sula Vineyards, and the Godavari River. It is a perfect destination for religious tours, wine tourism, and family vacations."
  },
 
  {
    title: "Ahmedabad",
    description: "Ahmedabad is Gujarat's largest city, famous for Sabarmati Ashram, Adalaj Stepwell, Kankaria Lake, and rich cultural heritage. It is a popular destination for business and leisure travelers."
  },
  {
    title: "Indore",
    description: "Indore is known for Rajwada Palace, Khajrana Ganesh Temple, Sarafa Night Market, Lal Bagh Palace, and nearby Ujjain and Omkareshwar. It is a preferred destination for business and religious travel."
  },
  {
    title: "Bangalore",
    description: "Bangalore is India's leading IT hub, famous for Lalbagh Botanical Garden, Cubbon Park, Bangalore Palace, ISKCON Temple, and vibrant shopping and dining destinations. It is a popular long-distance cab route from Mumbai."
  }
],



"services": [
  {
    "name": "Best Taxi Service in Mumbai",
    "description": "Book the Best Taxi Service in Mumbai for safe, comfortable, and reliable travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller options for airport transfers, local rides, corporate travel, sightseeing, family outings, and outstation trips with flexible one way and round trip booking."
  },
  {
    "name": "Best Cab Service Mumbai",
    "description": "Choose Best Cab Service Mumbai for premium transportation with experienced drivers, transparent pricing, and comfortable vehicles. Enjoy hassle-free travel for business meetings, airport transfers, family vacations, hotel pickups, and long-distance journeys with dependable service and timely pickups."
  },
  {
    "name": "Mumbai Taxi Service",
    "description": "Hire Mumbai Taxi Service for convenient local and outstation travel with clean AC vehicles, professional drivers, and affordable fares. Travel comfortably for office commutes, sightseeing, family trips, corporate travel, and airport transportation across Mumbai and beyond."
  },
  {
    "name": "Mumbai Taxi Booking",
    "description": "Complete Mumbai Taxi Booking with instant confirmation, multiple vehicle choices, and convenient doorstep pickup. Book Sedan, Ertiga, Innova Crysta, SUV, or luxury taxis for local, airport, and outstation travel at competitive prices."
  },
  {
    "name": "Online Taxi Booking Mumbai",
    "description": "Reserve Online Taxi Booking Mumbai with quick online reservations, instant booking confirmation, and reliable chauffeur-driven vehicles. Enjoy flexible travel schedules, professional service, and comfortable transportation for every journey."
  },
  {
    "name": "Mumbai Cab Service",
    "description": "Book Mumbai Cab Service for reliable city rides, airport transfers, business meetings, hotel pickups, family outings, and outstation travel. Experience comfortable rides with professional chauffeurs and well-maintained vehicles."
  },
  {
    "name": "Mumbai Car Rental Service",
    "description": "Choose Mumbai Car Rental Service for chauffeur-driven cars available for hourly, daily, local, and outstation travel. Enjoy premium comfort, flexible rental packages, and professional drivers for business and leisure travel."
  },
  {
    "name": "Mumbai Airport Taxi Service",
    "description": "Book Mumbai Airport Taxi Service for timely airport pickup and drop with flight tracking, experienced chauffeurs, and clean AC vehicles. Enjoy stress-free transfers to and from all Mumbai airport terminals with reliable service."
  },
  {
    "name": "Mumbai Outstation Taxi Service",
    "description": "Hire Mumbai Outstation Taxi Service for comfortable long-distance travel with one way and round trip options. Travel safely to destinations across Maharashtra and India with premium chauffeur-driven vehicles and affordable fares."
  },
  {
    "name": "Mumbai One Way Taxi",
    "description": "Choose Mumbai One Way Taxi for economical single-trip travel without paying return charges. Enjoy fixed pricing, comfortable vehicles, experienced drivers, and convenient pickup for intercity and outstation travel."
  },
  {
    "name": "Mumbai Round Trip Taxi",
    "description": "Book Mumbai Round Trip Taxi for flexible return journeys with affordable travel packages, reliable chauffeurs, and comfortable vehicles. Perfect for business tours, sightseeing, pilgrimages, family vacations, and weekend trips."
  },
  {
    "name": "Mumbai Corporate Taxi Service",
    "description": "Reserve Mumbai Corporate Taxi Service for executive travel, employee transportation, airport transfers, meetings, conferences, and corporate events. Enjoy punctual service with premium vehicles and experienced professional drivers."
  },
  {
    "name": "Mumbai Local Taxi Service",
    "description": "Hire Mumbai Local Taxi Service for convenient travel within the city with affordable fares, AC vehicles, and experienced chauffeurs. Ideal for shopping, office travel, hospital visits, railway station transfers, and daily commuting."
  },
  {
    "name": "Mumbai Private Taxi",
    "description": "Choose Mumbai Private Taxi for personalized chauffeur-driven travel with complete privacy, flexible schedules, and premium comfort. Suitable for business executives, families, tourists, and VIP transportation."
  },
  {
    "name": "Mumbai AC Taxi Service",
    "description": "Book Mumbai AC Taxi Service for cool and comfortable rides in well-maintained air-conditioned vehicles with professional drivers. Enjoy relaxing travel for local rides, airport transfers, business trips, and outstation journeys."
  },
  {
    "name": "Mumbai 24 Hours Taxi Service",
    "description": "Reserve Mumbai 24 Hours Taxi Service for round-the-clock transportation with quick availability, experienced chauffeurs, and dependable customer support. Get reliable taxi services anytime for airport transfers, emergency travel, and long-distance trips."
  },
  {
    "name": "Reliable Taxi Service Mumbai",
    "description": "Choose Reliable Taxi Service Mumbai for dependable transportation with trained chauffeurs, transparent pricing, quality vehicles, and excellent customer support. Enjoy safe, punctual, and comfortable travel for every occasion."
  },
  {
    "name": "Affordable Taxi Service Mumbai",
    "description": "Book Affordable Taxi Service Mumbai for budget-friendly transportation without compromising comfort or safety. Get competitive fares, professional drivers, clean AC vehicles, and reliable taxi service for local, airport, and outstation travel."
  }
],
"tableData": [
  ["Best Taxi Service in Mumbai", "Best Cab Service Mumbai"],
  ["Mumbai Taxi Service", "Mumbai Taxi Booking"],
  ["Online Taxi Booking Mumbai", "Mumbai Cab Service"],
  ["Mumbai Car Rental Service", "Mumbai Airport Taxi Service"],
  ["Mumbai Outstation Taxi Service", "Mumbai One Way Taxi"],
  ["Mumbai Round Trip Taxi", "Mumbai Corporate Taxi Service"],
  ["Mumbai Local Taxi Service", "Mumbai Private Taxi"],
  ["Mumbai AC Taxi Service", "Mumbai 24 Hours Taxi Service"],
  ["Reliable Taxi Service Mumbai", "Affordable Taxi Service Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "One of the Best Taxi Services in Mumbai for Every Journey",
    WhyChoosedescription: "Shreesha Tours & Travels delivers dependable taxi services across Mumbai with comfortable vehicles, professional chauffeurs, and flexible travel options for local rides, airport transfers, outstation tours, and interstate travel."
  },
  {
    WhyChooseheading: "Reliable Travel for Business & Leisure",
    WhyChoosedescription: "Whether you're attending corporate meetings, visiting tourist attractions, travelling with family, or planning a weekend getaway, our cab service is designed to provide a smooth and hassle-free experience."
  },
  {
    WhyChooseheading: "Large Fleet to Match Every Requirement",
    WhyChoosedescription: "Choose from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses for solo travellers, families, and large groups."
  },
  {
    WhyChooseheading: "Airport, Local & Outstation Taxi Specialists",
    WhyChoosedescription: "Book cabs for Mumbai Airport transfers, local city travel, corporate transportation, sightseeing tours, one-way trips, round trips, and long-distance destinations across India."
  },
  {
    WhyChooseheading: "Experienced Drivers with Route Expertise",
    WhyChoosedescription: "Our chauffeurs are familiar with Mumbai city roads, expressways, business districts, tourist attractions, and interstate highways, ensuring punctual and safe transportation."
  },
  {
    WhyChooseheading: "Flexible Booking Options for Every Schedule",
    WhyChoosedescription: "Reserve hourly rental cabs, full-day packages, one-way transfers, return journeys, or customized travel plans based on your convenience."
  },
  {
    WhyChooseheading: "Clean, Comfortable & Regularly Serviced Vehicles",
    WhyChoosedescription: "Every vehicle is maintained to high standards with air-conditioned interiors, comfortable seating, and ample luggage space to provide a pleasant journey."
  },
  {
    WhyChooseheading: "Trusted Service from Shreesha Tours & Travels",
    WhyChoosedescription: "With transparent pricing, quick booking assistance, and dedicated customer support, we strive to make every journey comfortable, reliable, and memorable."
  }
]

};

const faqData = [
  {
    question: "What makes Shreesha Tours & Travels one of the best taxi services in Mumbai?",
    answer: "We provide comfortable vehicles, experienced chauffeurs, transparent pricing, flexible travel options, and dependable customer support for every journey."
  },
  {
    question: "Can I hire a taxi for multiple destinations in one day?",
    answer: "Yes, customized city tours and multi-stop travel plans can be arranged according to your schedule."
  },
  {
    question: "Do you provide luxury vehicles for premium travel?",
    answer: "Yes, along with Sedan and SUV options, premium cars are available for business executives, VIP guests, and special occasions."
  },
  {
    question: "Is your taxi service available for weddings and special events?",
    answer: "Yes, we provide transportation for weddings, receptions, family functions, corporate events, and private celebrations."
  },
  {
    question: "Can I book a taxi for outstation trips from Mumbai?",
    answer: "Yes, we offer one-way and round-trip cab services to destinations across Maharashtra, Goa, Gujarat, Karnataka, Madhya Pradesh, Rajasthan, and many other states."
  },
  {
    question: "Do you provide airport pickup even for late-night flights?",
    answer: "Yes, airport transfers can be scheduled according to your flight arrival or departure time, including early morning and late-night pickups."
  },
  {
    question: "Are Tempo Travellers available for large groups?",
    answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, school trips, corporate outings, and group travel."
  },
  {
    question: "Can I choose the vehicle before confirming the booking?",
    answer: "Yes, you can select your preferred vehicle category based on passenger count, luggage, and travel budget."
  },
  {
    question: "Do you provide cabs for sightseeing around Mumbai?",
    answer: "Yes, you can book taxis for Mumbai sightseeing, nearby destinations, and customized full-day city tours."
  },
  {
    question: "How do I book the best taxi service in Mumbai with Shreesha Tours & Travels?",
    answer: "Share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive a personalized quotation and instant booking assistance."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Manish Kapoor",
    feedback: "I have used Shreesha Tours & Travels for airport transfers, business meetings, and outstation trips. Every ride has been punctual, comfortable, and professionally managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pallavi Desai",
    feedback: "Our family booked an Innova Crysta for a Mumbai sightseeing and weekend trip. The cab was immaculate, the driver was courteous, and the entire experience exceeded our expectations.",
    rating: 5
  }
]; 


















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Taxi Service in Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/best-taxi-service-in-mumbai.webp",
  "description":
    "Book the Best Taxi Service in Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, corporate travel, business meetings, city rides, family trips, and one-way or round-trip journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/best-taxi-service-in-mumbai"
  }
};







    return (
        <div>
<Helmet>
  <title>Best Taxi Service in Mumbai | Trusted Cab Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book the Best Taxi Service in Mumbai with Shreesha Travels for reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with experienced drivers, affordable fares, and 24x7 online booking."
  />

  <meta
    name="keywords"
    content="Best Taxi Service in Mumbai, Best Cab Service Mumbai, Mumbai Taxi Service, Mumbai Taxi Booking, Online Taxi Booking Mumbai, Mumbai Cab Service, Mumbai Car Rental Service, Mumbai Airport Taxi Service, Mumbai Outstation Taxi Service, Mumbai One Way Taxi, Mumbai Round Trip Taxi, Mumbai Taxi Hire, Affordable Taxi Service Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default BestTaxiServiceInMumbai;